import Highcharts from "highcharts";
import { chartConfig } from "../chart.commonConfig";
import { PDF_CONSTANT } from "../../../../constant";
import { chartsLoadedAction } from "../../../../actions/reports.action";
import { isEmpty } from "lodash";

export const CUMULATIVE_AVERAGE_DELAY_DASHBOARD_CHART_HELPER = data => {
  const BAR_CHART_CONFIG = {
    chart: {
      ...chartConfig.chart,
      zoomType: "xy",
      renderTo: "bar-chart",
      className: "chart-background",
      spacingBottom: 15,
      spacingRight: 50,
      marginTop: 47,
      marginLeft: 100,
      animation: {
        duration: 1000
      },
      events: {
        load: () => {
          chartsLoadedAction({
            type: PDF_CONSTANT.FIRST_PAGE.FIRST._SUCCESS
          });
        }
      }
    },
    title: {
      ...chartConfig.title,
      text: ""
    },
    xAxis: [
      {
        categories: [],
        className: "bar-label",
        lineWidth: 1,
        lineColor: "#2d79d3",
        tickColor: "#2d79d3",
        tickPosition: "inside",
        tickLength: 5,
        alignTicks: true,
        labels: {
          autoRotation: [-90],
          formatter: function() {
            return this.value;
          },
          style: {
            "font-weight": "300",
            "font-size": "13px",
            width: "75px",
            color: "black"
          }
        }
      }
    ],
    yAxis: [
      {
        className: "bar-label",
        lineWidth: 1,
        lineColor: "#2d79d3",
        alignTicks: true,
        labels: {
          format: `{value}`,
          style: {
            "font-weight": "300",
            color: "black",
            "font-size": "13px"
          }
        },
        title: {
          text: "Average Delay (days)",
          style: {
            color: "black",
            "font-size": "15px"
          },
          margin: 20
        },
        allowDecimals: false,
        gridLineColor: "#e7f1fb"
      }
    ],
    tooltip: {
      shared: true,
      formatter: function() {
        const { points } = this;
        return `${this.x}<br/>Delay (Days): <b>${points[0].y}</b><br/>`;
      }
    },
    series: [
      {
        name: "Project Stages",
        type: "column",
        yAxis: 0,
        zIndex: 1,
        data: [],
        dataLabels: {
          allowOverlap: true,
          enabled: true,
          style: {
            textOutline: "none"
          }
        },
        color: "#2d79d3"
      },
      {
        name: "Project Stages",
        showInLegend: false,
        type: "spline",
        yAxis: 0,
        zIndex: 1,
        data: [],
        lineWidth: 1,
        dataLabels: {
          enabled: false
        },
        color: "#EA833A"
      }
    ],
    plotOptions: {
      series: {
        animation: true,
        events: {
          legendItemClick: function(event) {
            event.preventDefault();
          }
        }
      },
      column: {
        pointWidth: 30
      }
    },
    legend: {
      symbolWidth: 0,
      symbolHeight: 0,
      squareSymbol: false,
      itemStyle: {
        fontSize: "15px"
      }
    }
  };

  // extract data for charts
  const barChartdata = { bucket: [], delay: [] };
  if (!isEmpty(data)) {
    data.bucketDTOList.forEach(({ bucket, delay }) => {
      barChartdata.bucket.push(bucket.name);
      barChartdata.delay.push(delay);
    });
  }

  BAR_CHART_CONFIG.xAxis[0].categories = barChartdata.bucket;
  BAR_CHART_CONFIG.series[0].data = barChartdata.delay;
  BAR_CHART_CONFIG.series[1].data = barChartdata.delay;
  BAR_CHART_CONFIG.yAxis[0].max = Math.max(...barChartdata.delay);
  BAR_CHART_CONFIG.yAxis[0].tickAmount = 6;

  return BAR_CHART_CONFIG;
};
